<template>
  <div
    class="
      flex
      w-full
      relative
      h-10
      border
      rounded-lg
      text-white
      border-grey-700
      bg-grey-800
    "
  >
    <div
      v-if="countType !== 'increment'"
      class="
        flex
        justify-center
        items-center
        h-full
        border-r border-grey-700
        text-grey-500 text-3xl
        leading-none
        select-none
        cursor-pointer
        w-10
      "
      @click="decrement"
    >
      -
    </div>
    <input
      type="number"
      inputmode="numeric"
      class="bg-transparent flex-grow h-full px-2 py-1 focus:outline-none"
      :value="value"
      :readonly="true"
      :max="max"
      :min="min"
      step="1"
      pattern="[0-9]*"
    />
    <div
      v-if="countType !== 'decrement'"
      class="
        flex
        justify-center
        items-center
        h-full
        border-l border-grey-700
        text-grey-500 text-3xl
        leading-none
        select-none
        cursor-pointer
        w-10
      "
      @click="increment"
    >
      +
    </div>
  </div>
</template>

<script>
export default {
  name: 'Counter',
  props: {
    countType: {
      type: String,
      required: false,
      default: 'both',
      validator: value => ['both','increment','decrement'].includes(value)
    },
    value: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      default: 10,
    },
    min: {
      type: Number,
      default: 1,
    }
  },
  methods: {
    increment() {
      const val = this.value < this.max ? this.value + 1 : this.value;
      this.$emit('input', val);
      this.$emit('change', val);
    },
    decrement() {
      const val = this.value > this.min ? this.value - 1 : this.value;
      this.$emit('input', val);
      this.$emit('change', val);
    },
  },
};
</script>

<style scoped>
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance: textfield;
}
</style>